import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import Button from '../UiComponents/Button';
import { ReactComponent as HotelsRclSvg } from '../../assets/svg/hotels-rcl.svg';
import { ReactComponent as HotelsCelSvg } from '../../assets/svg/hotels-cel.svg';
import { ReactComponent as TransfersSvg } from '../../assets/svg/transfers-rcl.svg';
import useStyles from './useStyles';

const TravelPlanCard = ({
  icon,
  cardTitle,
  cardInfo,
  supportPhoneNumber,
  ctaLabel,
  ctaOnClick,
}) => {
  const classes = useStyles();

  const getCardIcon = () => {
    switch (icon) {
      case 'rcl-hotels':
        return <HotelsRclSvg />;
      case 'cel-hotels':
        return <HotelsCelSvg />;
      case 'transfers':
        return <TransfersSvg />;
      default:
        return <TransfersSvg />;
    }
  };
  return (
    <Paper className={classes.travelPlanPaper}>
      {getCardIcon()}
      <div className={classes.infoWrapper}>
        <Typography variant="h6">{cardTitle}</Typography>
        <Typography variant="body2">
          {cardInfo}
          {supportPhoneNumber && <a href={`tel:${supportPhoneNumber}`}>{supportPhoneNumber}.</a>}
        </Typography>
      </div>
      {ctaLabel && (
        <Button
          className={classes.travelCTA}
          variant="outlined"
          color="primary"
          onClick={ctaOnClick}>
          {ctaLabel}
        </Button>
      )}
    </Paper>
  );
};
TravelPlanCard.propTypes = {
  icon: PropTypes.string,
  cardTitle: PropTypes.string,
  cardInfo: PropTypes.string,
  supportPhoneNumber: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaOnClick: PropTypes.func,
};

export default TravelPlanCard;
